import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_SCHEDULE_TIMING,
    saveScheduleTimingFail,
    saveScheduleTimingSuccess
} from '../action/saveScheduleTimingAction'

// api 
import saveScheduleTimingApi from '../api/saveScheduleTimingApi'

export function* saveScheduleTimingSaga(action) {
    try {
      const response = yield call(() => saveScheduleTimingApi(action.params));
      if (response.data.status === 1) {
        console.log(response.data)
        yield put(saveScheduleTimingSuccess(response, action));
      } else {
        yield put(saveScheduleTimingFail(response, action));
      }
    } catch (e) {
      yield put(saveScheduleTimingFail(e.response, action));
    }
  }
  
  export default function* mySaga() {
    yield takeLatest(SAVE_SCHEDULE_TIMING, saveScheduleTimingSaga);
  }
  
 